import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from 'app/_services/report.service';

import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap';
import { BrandComparisonReportService } from './brand-comparison-reports.service';
import { ProjectsService } from 'app/_services/projects.service';
const moment = require('moment');
@Component({
  selector: 'app-brands',
  templateUrl: './brand-comparison-reports.component.html',
  styleUrls: ['./brand-comparison-reports.component.scss']
})
export class BrandComparisonReportsComponent implements OnInit {
  projectId = "";
  typeAction = 'create';
  brandDropDownSettings: any;
  brandSelected = [];
  brandSelectedFilter = [];
  brands = [
  ];
  notSpam = false;
  brandComparisonDropDownSettings: any;
  brandComparisonSelected = [];
  brandComparisonSelectedFilter = [];
  brandComparisons = [
  ];
  brandComparisonsFilter = [
  ];
  brandComparisonFilterContent = [];
  brandComparisonFilterContentSelected = [];
  soureType = [
    {
      id: 1,
      itemName: "Báo chí",
      value: "Báo chí"
    },
    {
      id: 2,
      itemName: "Fanpage",
      value: "Fanpage"
    }
  ];
  soureTypeSelected = [];
  reportName = "";
  dataReport: Object;
  projectDropDownSettings: any;
  projectSelected = [];
  projects = [];

  typeReport = 1;
  typeReportFilter = 1;
  dataBrandFilter = [];
  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  keywords = '';
  imageSrc: any;
  file: null;
  result: any;
  source_keywords = '';
  listBrands = [];
  dataList = [];
  dataTableShow = false;
  showReport = false;
  currentConfigItem: object;
  modalRef: BsModalRef;
  daterange: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  daterangeFilter: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  options = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };
  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };

  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;
  }
  selectedDateFilter(value: any, datepicker?: any) {

    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
    this.optionsFilter = {
      locale: { format: 'DD/MM/YYYY' },
      timePicker: false,
      timePicker24Hour: true,
      timePickerSeconds: true,
      alwaysShowCalendars: false,
      maxDate: moment().subtract(1, "days").endOf('day').toDate(),
      startDate: this.daterangeFilter.start,
      endDate: this.daterangeFilter.end
    };

  }
  ckeditorContent = ``;
  public config2 = {
    keyboard: false,
      backdrop: 'static',
    class: 'modal-lg'
  };
  public config1 = {
    keyboard: false,
      backdrop: 'static',
    class: 'modal-sm'
  };

  selectedProjects = [];
  recommandDiscussTopic = [];
  recommandAdd = {};
  constructor(
    private projectsService: ProjectsService,
    private toastrService: ToastrService,
    private brandReportService: BrandComparisonReportService,
    private modalService: BsModalService
  ) {
    this.getDataFromServer();
    this.getProject();
    this.getReportManager();
  }

  ngOnInit(): void {
    this.brandDropDownSettings = {
      singleSelection: true,
      text: 'Vui lòng chọn',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.brandComparisonDropDownSettings = {
      singleSelection: false,
      text: 'Chọn thương hiệu so sánh',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    }
    this.projectDropDownSettings = {
      singleSelection: false,
      text: 'Chọn chủ đề',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0, 1, 2, 3, 4, 5], 'searchable': true }
      ]
    };
    this.dtOptions2 = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0, 1, 2], 'searchable': true }
      ]
    };
  };
  resolveAfter1Seconds() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve('resolved');
      }, 1000);
    });
  }


  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let projectItem = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(projectItem);
        });
      }
    });

  }

  clickArticleTopic(modalRef) {
    this.recommandDiscussTopic = [];
    this.brandComparisonFilterContentSelected = [];
    this.soureTypeSelected = [];
    this.modalRef.hide();
    this.modalRef = this.modalService.show(modalRef, this.config2);
  }
  clickSaveRecommand(item) {
    let type = this.soureTypeSelected[0].id;
    let obj = {
      id: (type == 1) ? item["_source"]["topicId"] : item["_source"]["docId"],
      title: (type == 1) ? item["_source"]["name"] : item["_source"]["message"],
      content: (type == 1) ? item["_source"]["content"] : item["_source"]["message"],
      createDate: item["_source"]["createDate"]
    }
    let key = this.brandComparisonFilterContentSelected[0]["itemName"];
    if (this.recommandAdd[key]) {
      this.recommandAdd[key].push(obj);
    } else {
      this.recommandAdd[key] = Array();
      this.recommandAdd[key].push(obj);
    }
    console.log(this.recommandAdd);
    // this.recommandAdd.push(obj);
  }
  clickRemoveRecommand(item) {
    let key = this.brandComparisonFilterContentSelected[0]["itemName"];
    let type = this.soureTypeSelected[0].id;
    let data = (this.recommandAdd[key]) ? this.recommandAdd[key] : [];
    for (var i = 0; i < data.length; i++) {
      if ((type == 1 && data[i]["id"] == item["_source"]["topicId"]) || (type == 2 && data[i]["id"] == item["_source"]["docId"])) {
        data.splice(i, 1);
      }
    }
    this.recommandAdd[key] = data;
    console.log(this.recommandAdd);
  }
  checkExitsRecommand(item) {
    let check = false;
    if (this.brandComparisonFilterContentSelected.length > 0 && this.soureTypeSelected.length > 0) {
      let key = this.brandComparisonFilterContentSelected[0]["itemName"];
      let type = this.soureTypeSelected[0].id;
      let data = (this.recommandAdd[key]) ? this.recommandAdd[key] : [];
      for (var i = 0; i < data.length; i++) {
        if ((type == 1 && data[i]["id"] == item["_source"]["topicId"]) || (type == 2 && data[i]["id"] == item["_source"]["docId"])) {
          check = true;
        }
      }
    }
    return check;
  }
  clickSaveDataReport(modalRef) {
    let data = Object.assign([], this.dataReport["data"]["brandDiscusss"]);
    for (var i = 0; i < data.length; i++) {
      let key = data[i]["name"];
      if (this.recommandAdd[key]) {
        let contents = Object.assign([], this.recommandAdd[key]);
        let content = "";
        for (var j = 0; j < contents.length; j++) {
          content += contents[j]["content"];
          if (j < (contents.length - 1)) {
            content += "<br>";
          }
        }
        data[i]["content"] = content;
      }
    }

    let copy = Object.assign({}, this.dataReport);
    copy["data"]["brandDiscusss"] = data;
    this.dataReport = {};
    this.dataReport = Object.assign({}, copy);
    this.closeModal();
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }
  getDataFromServer() {
    this.dataTableShow = false;
    this.brandReportService.getAll().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error('Lỗi hệ thống, Vui lòng liên hệ admin', ' Thông báo')
      }
    });
  }

  getReportManager() {
    this.dataTableShow = false;
    let type = "day";
    if (this.typeReport == 2) {
      type = "week";
    } else if (this.typeReport == 3) {
      type = "month";
    } else if (this.typeReport == 4) {
      type = "year";
    } else if (this.typeReport == 5) {
      type = "option";
    }
    let filter = {
      gte: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      brands: this.brandSelected,
      typeReport: type,
      report_code: ["SSTH"]
    };
    this.brandReportService.getAllReportManager(filter).subscribe(response => {
      this.dataTableShow = true;
      this.dataList = response.data;
      console.log(this.dataList);
    });
  }

  clickReport() {
    if (this.brandSelectedFilter.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu", "Thông báo!");
      return;
    }
    this.dataReport = {};
    this.recommandAdd = [];
    let type = "day";
    if (this.typeReportFilter == 2) {
      type = "week";
    } else if (this.typeReportFilter == 3) {
      type = "month";
    } else if (this.typeReportFilter == 4) {
      type = "year";
    } else if (this.typeReportFilter == 5) {
      type = "option";
    }
    let gte = this.daterangeFilter.start.valueOf();
    if (type == "day") {
      gte -= 6 * 24 * 60 * 60 * 1000;
    }

    // let timeRange = Math.ceil((this.daterangeFilter.end.valueOf() - this.daterangeFilter.start.valueOf()) / (24 * 60 * 60 * 1000));
    // if (timeRange > 60) {
    //   this.toastrService.warning("Khoảng thời gian chọn không được quá 60 ngày!", "Thông báo!");
    //   return;
    // }

    if (this.brandComparisonSelectedFilter.length == 0 || this.brandComparisonSelectedFilter.length > 3) {
      this.toastrService.warning("Bạn phải chọn thương hiệu so sánh, không được chọn nhiều hơn 3 thương hiệu!", "Thông báo!");
      return;
    }

    let filter = {
      from: this.daterangeFilter.start.valueOf(),
      gte: gte,
      lte: this.daterangeFilter.end.valueOf(),
      brandComparisons: this.brandComparisonSelectedFilter,
      brands: this.brandSelectedFilter,
      type: type,
      notSpam: this.notSpam
    };
    this.brandReportService.getReport({ filter: filter, index: "full" }).subscribe(response => {
      this.brandComparisonFilterContent = [];
      let data = response.data;
      if (data) {
        let aggregations = data.aggregations;

        let dataByBrands = aggregations.dataFilter;
        let brandMain = { name: this.brandSelectedFilter[0].itemName, id: this.brandSelectedFilter[0].id };
        let totalDiscuss = 0;

        let arrBrandDiscuss = Array();

        for (const property in dataByBrands) {
          if (dataByBrands[property] && dataByBrands[property]["statistic"]) {
            totalDiscuss += parseInt(dataByBrands[property]["statistic"]["data"]["post"]["doc_count"]) + parseInt(dataByBrands[property]["statistic"]["data"]["comment"]["doc_count"]);

            let id = "";
            if (property == this.brandSelectedFilter[0].itemName) {
              id = this.brandSelectedFilter[0].id;
            } else {
              for (var i = 0; i < this.brandComparisonSelectedFilter.length; i++) {
                if (property == this.brandComparisonSelectedFilter[i].itemName) {
                  id = this.brandComparisonSelectedFilter[i].id;
                }
              }
            }

            if (brandMain["name"] == property) {
              brandMain["post"] = parseInt(dataByBrands[property]["statistic"]["data"]["post"]["doc_count"]);
              brandMain["comment"] = parseInt(dataByBrands[property]["statistic"]["data"]["comment"]["doc_count"]);
            } else {
              let objFilterBrand = {
                id: id,
                itemName: property,
                value: property
              };
              this.brandComparisonFilterContent.push(objFilterBrand);
            }


            let obj = {
              id: id,
              name: property,
              title: property,
              content: "",
              post: parseInt(dataByBrands[property]["statistic"]["data"]["post"]["doc_count"]),
              comment: parseInt(dataByBrands[property]["statistic"]["data"]["comment"]["doc_count"])
            }
            arrBrandDiscuss.push(obj);
          }
        }
        if (arrBrandDiscuss.length > 1) {
          for (var i = 0; i < arrBrandDiscuss.length; i++) {
            let totalI = parseInt(arrBrandDiscuss[i]["post"]) + parseInt(arrBrandDiscuss[i]["comment"]);
            for (var j = i + 1; j < arrBrandDiscuss.length; j++) {
              let totalJ = parseInt(arrBrandDiscuss[j]["post"]) + parseInt(arrBrandDiscuss[j]["comment"]);
              if (totalI < totalJ) {
                let tmp = Object.assign({}, arrBrandDiscuss[i]);
                arrBrandDiscuss[i] = Object.assign({}, arrBrandDiscuss[j]);
                arrBrandDiscuss[j] = Object.assign({}, tmp);
              }
            }
          }
        }

        let arrBrandCompare = Array();
        for (var i = 0; i < arrBrandDiscuss.length; i++) {
          let totalI = parseInt(arrBrandDiscuss[i]["post"]) + parseInt(arrBrandDiscuss[i]["comment"]);
          if (arrBrandDiscuss[i]["name"] != brandMain["name"]) {
            if (i == 0) {
              arrBrandDiscuss[i]["title"] = "<b>" + arrBrandDiscuss[i]["name"] + " đứng đầu</b> thị phần thảo luận, chiểm <b>" + ((totalI / totalDiscuss) * 100).toFixed(2) + "%</b>, nội dung chính:";
            } else if (i < (arrBrandDiscuss.length - 1)) {
              arrBrandDiscuss[i]["title"] = "<b>" + arrBrandDiscuss[i]["name"] + "</b> đứng thứ " + (i + 1) + " về lượng thảo luận, chiểm <b>" + ((totalI / totalDiscuss) * 100).toFixed(2) + "%</b>, nội dung chính:";
            } else {
              arrBrandDiscuss[i]["title"] = "<b>" + arrBrandDiscuss[i]["name"] + "</b> đứng cuối về lượng thảo luận, chiểm <b>" + ((totalI / totalDiscuss) * 100).toFixed(2) + "%</b>, nội dung chính:"
            }
            arrBrandCompare.push(Object.assign({}, arrBrandDiscuss[i]));
          }

        }


        this.dataReport = {
          report_desc: "So sánh thương hiệu " + brandMain["name"] + " và đối thủ",
          report_type: type,
          report_name: "So sánh thương hiệu " + brandMain["name"] + " và đối thủ từ ngày " + this.daterangeFilter.start.format('DD/MM/YYYY') + " đến ngày " + this.daterangeFilter.end.format('DD/MM/YYYY'),
          report_project: null,
          report_brand: this.brandSelectedFilter,
          report_start_date: new Date(this.daterangeFilter.start.valueOf()),
          report_end_date: new Date(this.daterangeFilter.end.valueOf()),
          report_code: "SSTH",
          data: {
            totalDiscuss: totalDiscuss,
            brandMain: brandMain,
            brandDiscusss: arrBrandCompare
          }
        }
      }
    });
    // console.log(filter);
  }
  showPreviewReport(item, modalRef) {
    this.typeAction = 'view';
    this.dataReport = {};
    // let await1s = await this.resolveAfter1Seconds()
    this.dataReport = JSON.parse(JSON.stringify(item));
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }
  showCreateReport(modalRef) {
    this.typeAction = 'create';
    this.dataReport = {};
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });

  }
  modalRefHide(previewModal = null) {
    this.modalRef.hide();
    if (previewModal) {
      this.modalRef = this.modalService.show(previewModal, {
        keyboard: false,
        backdrop: 'static',
        class: 'custom-modal'
      });
    }
  }

  clickEditReportItem(item, modalRef) {
    this.brandComparisonFilterContent = [];
    this.brandComparisonFilterContentSelected = [];
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
    //cap nhat list thuong hieu so sanh
    this.dataBrandFilter = Object.assign([], this.currentConfigItem["data"]["brandDiscusss"]);
    for (var i = 0; i < this.dataBrandFilter.length; i++) {
      let obj = {
        id: this.dataBrandFilter[i]["id"],
        itemName: this.dataBrandFilter[i]["name"],
        value: this.dataBrandFilter[i]["name"]
      };
      this.brandComparisonFilterContent.push(obj);
    }
    this.brandComparisonFilterContentSelected.push(Object.assign([], this.brandComparisonFilterContent[0]));
    this.ckeditorContent = this.dataBrandFilter[0]["content"];
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-lg'
    });
  }
  clickSave() {
    if (this.dataReport) {
      if (this.reportName == "") {
        this.toastrService.warning("Bạn phải nhập tiêu đề cho báo cáo!", "Thông báo!");
        return;
      }

      this.dataReport["report_title"] = this.reportName.trim();
      this.brandReportService.createReportManager(this.dataReport).subscribe(response => {
        if (response.success) {
          this.toastrService.success("Đã thêm mới thành công!", "Thông báo!");
          this.getReportManager();
        } else {
          this.toastrService.warning(response.msg, "Thông báo!");
        }
        this.closeModal();
      });
    } else {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
    }
  }
  clickDeleteItem(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef);
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
  }
  clickSaveConfirm(modalRef) {
    if (!this.dataReport) {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
      return;
    }
    this.reportName = "";
    this.modalRef.hide();
    this.modalRef = this.modalService.show(modalRef);
  }

  async onCkEditorChange(item) {
    this.ckeditorContent = item.toString();
    for (var i = 0; i < this.dataBrandFilter.length; i++) {
      if (this.dataBrandFilter[i]["id"] == this.brandComparisonFilterContentSelected[0]["id"]) {
        this.dataBrandFilter[i].content = this.ckeditorContent;
      }
    }
  }

  saveEditPost() {
    this.currentConfigItem["data"]["brandDiscusss"] = Object.assign([], this.dataBrandFilter);
    this.brandReportService.updateReport(this.currentConfigItem['_id'], this.currentConfigItem['data']).subscribe(res => {

      if (res.success) {
        this.toastrService.success('Cập nhật báo cáo thành công', 'Thông báo');
        this.modalRef.hide();
        this.getReportManager();
        this.dataReport = null;
        this.dataReport = this.currentConfigItem;
      }
    });
  }

  deleteReport() {
    this.brandReportService.deleteReport(this.currentConfigItem['_id']).subscribe(res => {
      if (res.success) {
        this.getReportManager();
        this.toastrService.success('Xóa báo cáo thành công !', 'Thông báo');
        this.closeModal();
      } else {
        this.toastrService.error('Xóa báo cáo thất bại !', 'Thông báo');
      }
    });
  }
  closeModal() {
    this.modalRef.hide();
  }

  onItemSelect(item: any, brand = null) {
    if (brand) {
      this.brandComparisons = [];
      for (var i = 0; i < this.brands.length; i++) {
        let id = this.brands[i].id;
        let idSelected = item.id;
        if (id != idSelected) {
          this.brandComparisons.push(this.brands[i]);
        }
      }
      this.brandComparisonSelected = [];
    }
  }
  onItemSelectFilter(item: any, brand = null) {
    if (brand) {
      this.brandComparisonsFilter = [];
      for (var i = 0; i < this.brands.length; i++) {
        let id = this.brands[i].id;
        let idSelected = item.id;
        if (id != idSelected) {
          this.brandComparisonsFilter.push(this.brands[i]);
        }
      }
      this.brandComparisonSelectedFilter = [];
    }
  }
  onItemSelectContent(item) {
    if (this.brandComparisonFilterContentSelected.length > 0 && this.soureTypeSelected.length > 0) {
      let filter = {
        sourceType: this.soureTypeSelected,
        brands: this.brandComparisonFilterContentSelected,
        gte: new Date(this.dataReport["report_start_date"]).getTime(),
        lte: new Date(this.dataReport["report_end_date"]).getTime()
      };
      this.recommandDiscussTopic = [];
      this.brandReportService.getTopicComparison({ filter: filter }).subscribe(response => {
        if (response.data && response.data.hits && response.data.hits.hits) this.recommandDiscussTopic = response.data.hits.hits;
      });
    }
  }
  onItemSelectUpdate(item) {
    for (var i = 0; i < this.dataBrandFilter.length; i++) {
      if (this.dataBrandFilter[i]["id"] == item["id"]) {
        this.ckeditorContent = this.dataBrandFilter[i]["content"];
      }
    }
  }
  OnItemDeSelect(item: any, brand = null) {
  }
  OnItemDeSelectContent(item: any) {
    this.recommandDiscussTopic = [];
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/brand-comparison/brand-comparison-reports.component.ts